import React, { useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
// import placeholderImg from "../assets/images/new/fav-removebg-preview.png";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
// import StupaImg from "../Images/stupa.jpg";
import "./ThankYou.css";
import { Link, Links } from "react-router-dom";
import DownloadApp from "../DownLoadApp/DownloadApp";
import { t } from "i18next";
import { LoaderContext } from "../../AuthContext/AuthContext";

const ThankYou = () => {
  const location = useLocation();
  const { selectedLanguageID } = useContext(LoaderContext);
  const navigate = useNavigate();


  const HandleOrderPage = () => {
    if (location?.state?.moduleName === "PujaBooking") {
      navigate("/my-order-puja-booking");
    } else if (location?.state?.moduleName === "PrasadBooking") {
      navigate("/my-orders", { state: { pujaType: 9 } });
    } else if (location?.state?.moduleName === "DailyPujaBooking") {
      navigate("/my-order-daily-Booking");
    } else if (location?.state?.moduleName === "MyStore") {
      navigate("/my-orders", { state: { pujaType: 8 } });
    } else if (location?.state?.moduleName === "DarshanBooking") {
      navigate("/my-orders", { state: { pujaType: 10 } });
    } else if (location?.state?.moduleName === "PujaAtTemple") {
      navigate("/my-orders", { state: { pujaType: 7 } });
    } else if (location?.state?.moduleName === "pujaKitSubscription") {
      navigate("/puja-kit-orders");

    } else if (location?.state?.moduleName === "RemedyPuja") {
      navigate("/my-orders", { state: { pujaType: 3 } });
    } else if (location?.state?.moduleName === "HomamPuja") {
      navigate("/my-orders", { state: { pujaType: 4 } });
    } else if (location?.state?.moduleName === "PanditBooking") {
      navigate("/my-orders", { state: { pujaType: 1 } });
    } else if (location?.state?.moduleName === "DailyPanditBooking") {
      navigate("/my-orders", { state: { pujaType: 2 } });
    } else if (location?.state?.moduleName === "SubscriptionRemedyBooking") {
      navigate("/my-orders", { state: { pujaType: 5 } });
    } else if (location?.state?.moduleName === "SubscriptionHomamBooking") {
      navigate("/my-orders", { state: { pujaType: 6 } });
    } else if (location?.state?.moduleName === "PujaAtTemple") {
      navigate("/my-orders", { state: { pujaType: 7 } });
    } else if (location?.state?.moduleName === "Pujakit") {
      navigate("/my-orders", { state: { pujaType: 11 } });
    }




  };
  return (
    <>

      <div className="thank-you--order-main">
        <div className="">
          <div>
            <img
              src={placeholderImg}
              alt="404"
              className="error-404__image"
              style={{ height: "12em" }}
            />
          </div>
          {location?.state?.moduleName === null || location?.state?.moduleName === undefined ? (
            <h3 className="error-404__text">{("Thank you for visiting Myomnamo!")} </h3>
          ) : (
            <h3 className="error-404__text">
              {location?.state?.moduleName === 'PanditRegister' ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{t("Thank you for registering as a Pandit.")}<br />  {t("To manage your bookings and profile easily,")}{" "}
                <a
                  href="https://play.google.com/store/apps/details?id=app.myomnamopartner"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                >
                  {t("download")}
                </a>{" "}
                {t("our app now.")}
              </span> :
                location?.state?.moduleName === 'pujaKitSubscription' ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{t("Thank you for subscribing.")} <br /> {t("We appreciate your interest and look forward to staying connected.")}</span> : location?.state?.moduleName === 'ContactUs' ? <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{t("Thank you for contact us.")} <br /> {t("We have received your message and will get back to you shortly.")}</span> : <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{t("Thank you for booking with Myomnamo")}! <br /> <span style={{ fontWeight: 'normal', fontSize: '18px' }}>{t("Your booking has been placed successfully.")}<br /> {t("We appreciate your trust in us and will keep you updated on your order status.")}</span></span>}
              { }
            </h3>
          )}
          {location?.state?.moduleName !== null && location?.state?.moduleName !== undefined ? (
            <div className="error-404__btns ">

              <button
                style={{ padding: "10px 20px", fontSize: "18px" }}
                onClick={() => {
                  navigate("/");
                }}
                className="download-app-btn mx-3    "
              >
                {t("Home")}
              </button>
              {(location?.state?.moduleName !== 'PanditRegister' && location?.state?.moduleName !== 'ContactUs') && (
                <button
                  style={{ padding: "10px 20px", fontSize: "18px" }}
                  onClick={() => HandleOrderPage()}
                  className="Normal-app-btn "
                >
                  {t("My Order")}
                </button>
              )}

            </div>
          ) : <button
            style={{ padding: "10px 20px", fontSize: "18px" }}
            onClick={() => {
              navigate("/");
            }}
            className="Normal-app-btn mx-3"
          >
            {t("Home")}
          </button>}

        </div>

      </div>
      {location?.state?.moduleName === 'PanditRegister' && (

        <DownloadApp languageID={selectedLanguageID == 3 ? 1 : null} />
      )}
    </>
  );
};

export default ThankYou;
